<template>
  <div class="wrapper">
    <!-- Navigation component -->
    <dashboardNav />

    <!-- Page Content  -->
    <div id="content">
      <router-view />
    </div>
  </div>
</template>

<script>
import '@/assets/styles/dashboard.css'

import DashboardNav from '@/components/common/DashboardNav'

export default {
  components: {
    dashboardNav: DashboardNav
  },
  data() { return {} },
  mounted() {}
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/containers/Dashboard.vue